<template>
  <div class="ov-page">
    <div class="ov-header">
      <div>
        <h1 class="ov-header__title">{{ $t('users.userDetails') }}</h1>
        <p class="ov-header__subtitle mt-1">{{ $t('users.userDetailsSubtitle') }}</p>
      </div>
      <div class="ov-header__actions">
        <button type="button" class="ov-btn ov-btn--secondary" @click="$router.go(-1)">
          <v-icon small>mdi-arrow-left</v-icon>
          Retour
        </button>
      </div>
    </div>

    <div class="ov-grid">
      <div class="ov-stack">
        <UserInfo :account="user" />
        <UserFunctionnalities :functionnalities="userFunctionnalyList" />
      </div>
      <div class="ov-stack">
        <UserStatus :account="user" @account-activated="handleAccountActivated" />
        <UserActivities :account="user" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_GET_ALL_USERS_CREATED,
  HEADERS,
  API_GET_ALL_ROLES,
  API_GET_FUNCTIONNALITY_BY_USER_ROLE,
} from "@/components/globalConfig/globalConstConfig";
import UserInfo from "../widgets/status_account/UserInfo.vue";
import UserActivities from "../widgets/status_account/userActivities.vue";
import UserStatus from "../widgets/status_account/UserStatus.vue";
import UserFunctionnalities from "../widgets/status_account/userFunctionnalities.vue";
import { showErrorMessage } from "@/modules/messages/messageProcess";
export default {
  components: {
    UserInfo,
    UserActivities,
    UserStatus,
    UserFunctionnalities,
  },
  data() {
    return {
      user: {},
      simpleObjectToSend: {
        data: {},
      },

      toActive: {
        data: {
          login: null,
        },
      },

      gettingFunctionnalityData: {
        data: {
          code: null,
        },
      },

      userFunctionnalyList: [],
    };
  },

  methods: {
    // Gérer l'activation du compte utilisateur
    handleAccountActivated() {
      this.user.isActif = true;
    },

    // Recuperer la liste des fonctionnalités par rôle utilisateur
    async getFunctionnalitiesByUserRole(userRoleCode) {
      this.gettingFunctionnalityData.data.code = userRoleCode;
      await axios
        .post(
          API_GET_FUNCTIONNALITY_BY_USER_ROLE,
          this.gettingFunctionnalityData,
          {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              this.userFunctionnalyList = response.data.items;
            }
          } else {
            this.errorMsg = this.$t('users.error');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
    },

    // RECUPERER LA LISTE DES UTILISATEURS CREES SUR LA PLATEFORME
    async toGetAllUsersCreated() {
      await axios
        .post(API_GET_ALL_USERS_CREATED, this.simpleObjectToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              response.data.items.forEach((element) => {
                if (element.nom == this.$route.params.nom) {
                  this.user = element;
                  this.getFunctionnalitiesByUserRole(this.user.roleCode);
                }
              });
            }
          } else {
            this.errorMsg = this.$t('users.error');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
    },
    

    //RECUPERER LA LISTE DES ROLES CRÉES
    async getAllUserRole() {
      await axios
        .post(
          API_GET_ALL_ROLES,
          {},
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              response.data.items.forEach((element) => {
                if (element.code == this.user.roleCode) {
                  this.totalPermission = element.datasFunctionalities.length;
                }
              });
            }
          } else {
            this.errorMsg = this.$t('users.error');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.loadingUserRole = false;
        });
    },
  },

  mounted() {
    this.toGetAllUsersCreated();
    this.getAllUserRole();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";
</style>
